import { HttpClient, HttpHeaders, HttpResponseBase } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, catchError, tap } from 'rxjs';
import { environment } from '@env/environment';
import { HeadersActionsI } from '@shared/interface/global.interface';
import { CuitCuilModuloI } from './sidebar/sidebar.interface';
import { actionsUser } from '@constants/actions.constants';
import { TableService } from '@shared/components/table/table.service';
@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  private readonly _apiUrl = environment.apiUsuarios;
  private readonly token: string | null = localStorage.getItem('username');
  private readonly cuitCuil = '';

  private readonly genericTableLayout$ = new BehaviorSubject<{ width: string; height: string }>({ width: '100%', height: '100vh' });

  private readonly _tableSvc = inject(TableService);
  private readonly _http = inject(HttpClient);

  constructor() {
    const parsedToken = this.token ? JSON.parse(this.token) : null;
    const user = parsedToken ? parsedToken.user : '';
    this.cuitCuil = user.cuitCuilt;
  }

  getGenericTableLayoutConfig() {
    return this.genericTableLayout$.asObservable();
  }
  setGenericTableLayoutConfig(config: { width: string; height: string }) {
    return this.genericTableLayout$.next(config);
  }
  getCurrentStateGenericTableLayoutConfig() {
    return this.genericTableLayout$.getValue();
  }

  // ================== Observables ==================

  // ========== Verificar si tiene los roles y permisos para realizar acciones ==========
  private readonly isRolPermissionsActions: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);
  public isRolPermissionsActions$: Observable<string[]> = this.isRolPermissionsActions.asObservable();
  public getIsRolPermissionsActions(): string[] {
    return this.isRolPermissionsActions.getValue();
  }
  public setIsRolPermissionsActions(data: string[]): void {
    this.isRolPermissionsActions.next(data);
  }

  private readonly isSidebarSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  isSidebar$: Observable<boolean> = this.isSidebarSubject.asObservable();

  setIsSidebar(isShow: boolean): void {
    this.isSidebarSubject.next(isShow);
  }
  getIsSidebar(): Observable<boolean> {
    return this.isSidebar$;
  }

  private readonly actionsScreen: BehaviorSubject<string[]> = new BehaviorSubject<string[]>({} as string[]);
  actionsScreen$: Observable<string[]> = this.actionsScreen.asObservable();

  // =============== Endpoints ===============

  public getActionsScreen(params: HeadersActionsI): Observable<string[]> {
    const module = params.module.toLowerCase().replace(/_/g, '-').replace(/-/g, '-');
    const action = params.action.toLowerCase().replace(/_/g, '-').replace(/-/g, '-');
    const originResource = params['origin-resource'].toLowerCase().replace(/_/g, '-').replace(/-/g, '-');

    const headers = new HttpHeaders().set('module', module).set('action', action).set('origin-resource', originResource);

    const paramsUrl = `module=${module}&resource=${originResource}`;
    const url = `${this._apiUrl}/actions-by-users?${paramsUrl}`;

    return this._http.get<string[]>(url, { headers }).pipe(
      tap((resp: string[]) => {
        if (Array.isArray(resp) && resp.length > 0) {
          this.actionsScreen.next(resp);
          const actions = resp.map((action: string) => action.toLowerCase());
          this.rolPermissionsActions(actions);
          return resp;
        } else {
          this.actionsScreen.next([]);
          throw new Error('No tiene permisos para realizar esta acción');
        }
      }),
      catchError((err: HttpResponseBase) => {
        this.actionsScreen.next([]);
        throw err;
      }),
    );
  }

  public getCuitCuilModulo(cuitCuilt: number | string, modulo: string): Observable<CuitCuilModuloI> {
    const headers = new HttpHeaders().set('module', modulo).set('action', actionsUser.CONSULTA).set('origin-resource', 'menu');

    const url = `${this._apiUrl}/menues-by-user?modulo=${modulo}`;
    return this._http.get<CuitCuilModuloI>(url, { headers }).pipe(
      tap((resp: CuitCuilModuloI) => {
        return resp;
      }),
      catchError((err: HttpResponseBase) => {
        throw err;
      }),
    );
  }

  private rolPermissionsActions(actions: string[]): void {
    const actionTypes = ['alta', 'ejecutar', 'baja', 'consulta', 'modifica', 'exportar'];
    const validActions = actionTypes.filter((action) => actions.includes(action));

    // Emitir las acciones válidas
    this.setIsRolPermissionsActions(validActions);
  }
}
